import { ReactNode } from "react";
import { ScoreArc } from "../ScoreArc/ScoreArc";
import { Typography } from "../ui/Typography/Typography";
import "./ScoreCard.scss";

interface ScoreCardProps {
  title?: string;
  score: number;
  image?: string;
  imageAlt?: string;
  info?: string | ReactNode;
  label?: string;
  scoreSize?: "xSmall" | "small" | "medium" | "large";
}

export const ScoreCard = ({
  title,
  score,
  image,
  imageAlt = "",
  info,
  label,
  scoreSize = "large",
}: ScoreCardProps) => {
  return (
    <div className="ScoreCard">
      {title && (
        <div className="ScoreCard__header">
          <Typography tagVariant="h3" desktop="h3" className="ScoreCard__title">
            {title}
          </Typography>
          {image && (
            <img src={image} alt={imageAlt} className="ScoreCard__image" />
          )}
        </div>
      )}

      <div className="ScoreCard__scoreContainer">
        <ScoreArc score={score} size={scoreSize} label={label} />
      </div>

      {info && (
        <div className="ScoreCard__info">
          {typeof info === "string" ? (
            <Typography desktop="body2" className="ScoreCard__infoText">
              {info}
            </Typography>
          ) : (
            info
          )}
        </div>
      )}
    </div>
  );
};
